import { Aluminium1, Aluminium2, Aluminium3, Aluminium4, Aluminium5, ArrowBtnBrown, Client1, Client10, Client11, Client12, Client2, Client3, Client4, Client5, Client6, Client7, Client8, Client9, Finishing1, Finishing2, Finishing3, Finishing4, Finishing5, Finishing6, Finishing7, Finishing8, Interior1, Interior2, Interior3, PartnerIcon1, PartnerIcon2, PartnerIcon3, PartnerIcon4, PartnerIcon5, Portfolio1, Portfolio2, ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5, ServiceImg6, ServiceImg7, ServiceImg8, SmartHome1, SmartHome2, SmartHome3, SmartHome4, SmartHome5, SwimmingPool1, SwimmingPool10, SwimmingPool11, SwimmingPool12, SwimmingPool13, SwimmingPool14, SwimmingPool15, SwimmingPool2, SwimmingPool3, SwimmingPool4, SwimmingPool5, SwimmingPool6, SwimmingPool7, SwimmingPool8, SwimmingPool9 } from "../../ui/AllImages"
import { Box, LazyImage, SpanStyled } from "../../ui/Elements"
import i18n from '../../Languages/INEXT'


export const WhyChooseData = [
    {
        img: <LazyImage src={PartnerIcon1} />,
        // heading: "partnerTitle1",
        render: (t) => (
            <>
                {t('partnerTitle1')}
                {/* <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab1List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab1List1Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab1List1')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box> */}
                
            </>
        ),
        text: "partnerDesc1",
    },
    {
        img: <LazyImage src={PartnerIcon2} />,
        render: (t) => (
            <>
                {t('partnerTitle2')}
            </>
        ),
        text: "partnerDesc2",
    },
    {
        img: <LazyImage src={PartnerIcon3} />,
        render: (t) => (
            <>
                {t('partnerTitle3')}
            </>
        ),
        text: "partnerDesc3",
    },
    {
        img: <LazyImage src={PartnerIcon4} />,
        render: (t) => (
            <>
                {t('partnerTitle4')}
            </>
        ),
        text: "partnerDesc4",
    },
    {
        img: <LazyImage src={PartnerIcon5} />,
        render: (t) => (
            <>
                {i18n.language === "ar" ? 
                    <>
                        {t('partnerTitle5')}&nbsp;<SpanStyled className='' family='var(--familyRbtFlex)' weight='var(--bold)' color='var(--themeColor)'>{t('2030')}</SpanStyled>
                    </>
                : 
                    <>
                        {t('partnerTitle5')}
                    </>
                }
                
            </>
        ),
        text: "partnerDesc5",
    },
    
]

export const clientsItems = [
    {
        img: <img className='client-img' src={Client1} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client2} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client3} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client4} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client5} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client6} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client7} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client8} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client9} alt="client" />,
    },
    {
        img: <img className='client-img' src={Client10} alt="client" />,
    },
    {
        img: <img className='client-img' src={Client11} alt="client" />,
    },
    {
        img: <img className='client-img' src={Client12} alt="client" />,
    },
]
export const NavDataConfig = [
    {
        to: 'home',
        label: 'Home',
    },
    {
        to: 'about',
        label: 'About',
    },
    {
        to: 'service',
        label: 'Services',
    },
    {
        to: 'choose',
        label: 'Why_Choose_Us',
    },
    {
        to: 'gallery',
        label: 'Portfolio',
    },
    {
        to: 'client',
        label: 'Client',
    },

    {
        to: 'contact',
        label: 'Contact_Us',
    },
]

export const serviceMaintaneData = [
    {
        
        heading: 'servicesTabList1',
        number: '1',
        number2: '01',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab1List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab1List1Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab1List1')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List2')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List6')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab1List7')}</SpanStyled>
                </Box>
            </>
        ),
        // list: 
        
        // [

        //     'serTab1List1',
        //     'serTab1List2',
        //     'serTab1List3',
        //     'serTab1List4',
        //     'serTab1List5',
        //     'serTab1List6',
        //     'serTab1List7',
        // ]
    },
    {
        heading: 'servicesTabList2',
        number: '2',
        number2: '02',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab2List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab2List1Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab2List1')}
                            </>
                        }
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab2List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab2List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab2List2')}
                            </>
                        }
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab2List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab2List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab2List5')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab2List5Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab2List5')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab2List6')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab2List7')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab2List7Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab2List7')}
                            </>
                        }
                        
                        
                    </SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab2List1',
            'serTab2List2',
            'serTab2List3',
            'serTab2List4',
            'serTab2List5',
            'serTab2List6',
            'serTab2List7',
        ] */
    },
    {
        heading: 'servicesTabList3',
        number: '3',
        number2: '03',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab3List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab3List1Eng')}</SpanStyled>&nbsp;<SpanStyled color='var(--text2)'>{t('serTab3List1Ar2')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab3List1')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab3List2')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab3List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab3List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab3List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab3List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab3List1',
            'serTab3List2',
            'serTab3List3',
            'serTab3List4',
            'serTab3List5',
            'serTab3List6',
        ] */
    },
    {
        heading: 'servicesTabList4',
        number: '4',
        number2: '04',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab4List1')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab4List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab4List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab4List2')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab4List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab4List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab4List5')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab4List5Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab4List5')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab4List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab4List1',
            'serTab4List2',
            'serTab4List3',
            'serTab4List4',
            'serTab4List5',
            'serTab4List6',
        ] */
    },
    {
        heading: 'servicesTabList5',
        number: '5',
        number2: '05',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab5List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab5List1Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab5List1')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab5List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab5List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab5List2')}
                            </>
                        }
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab5List3')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab5List3Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab5List3')}
                            </>
                        }
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab5List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab5List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab5List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab5List1',
            'serTab5List2',
            'serTab5List3',
            'serTab5List4',
            'serTab5List5',
            'serTab5List6',
        ] */
    },
    {
        heading: 'servicesTabList6',
        number: '6',
        number2: '06',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab6List1')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab6List1Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab6List1')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab6List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab6List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab6List2')}
                            </>
                        }
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab6List3')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab6List3Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab6List3')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab6List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab6List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab6List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab6List1',
            'serTab6List2',
            'serTab6List3',
            'serTab6List4',
            'serTab6List5',
            'serTab6List6',
        ] */
    },
    {
        heading: 'servicesTabList7',
        number: '7',
        number2: '07',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab7List1')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab7List2')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab7List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab7List4')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab7List4Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab7List4')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab7List5')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab7List5Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab7List5')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab7List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab7List1',
            'serTab7List2',
            'serTab7List3',
            'serTab7List4',
            'serTab7List5',
            'serTab7List6',
        ] */
    },
    {
        heading: 'servicesTabList8',
        number: '8',
        number2: '08',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab8List1')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab8List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab8List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab8List2')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab8List3')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab8List3Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab8List3')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab8List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab8List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab8List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab8List1',
            'serTab8List2',
            'serTab8List3',
            'serTab8List4',
            'serTab8List5',
            'serTab8List6',
        ] */
    },
    {
        heading: 'servicesTabList9',
        number: '9',
        number2: '09',
        render: (t) => (
            <>
            
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab9List1')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>
                        {i18n.language === "ar" ? 
                            <>
                                {t('serTab9List2')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('serTab9List2Eng')}</SpanStyled>
                            </>
                        : 
                            <>
                                {t('serTab9List2')}
                            </>
                        }
                        
                    </SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab9List3')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab9List4')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab9List5')}</SpanStyled>
                </Box>
                <Box className='d-flex align-items-start gap-3 my-3'>
                    <Box className='serArrowList'>
                        <ArrowBtnBrown />
                    </Box>
                    <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t('serTab9List6')}</SpanStyled>
                </Box>
            </>
        ),
        /* list: [
            'serTab9List1',
            'serTab9List2',
            'serTab9List3',
            'serTab9List4',
            'serTab9List5',
            'serTab9List6',
        ] */
    },
]

/*
export const ServicesList1 = [
	{
		img: <LazyImage src={ServiceImg1} />,
		title: 'SLTitle1',
		txt: 'SLText1',
		listing: [ 
			{
				listTxt: 'SLList1_1',
			},
			{
				listTxt: 'SLList1_2',
			},
			{
				listTxt: 'SLList1_3',
			},
			
        ],
	},
    

]

export const ServicesList2 = [
	{
		img: <LazyImage src={ServiceImg2} />,
		title: 'SLTitle2',
		txt: 'SLText2',
		listing: [ 
			{
				listTxt: 'SLList2_1',
			},
			{
				listTxt: 'SLList2_2',
			},
			{
				listTxt: 'SLList2_3',
			},
			
        ],
	},
    

]

export const ServicesList3 = [
	{
		img: <LazyImage src={ServiceImg3} />,
		title: 'SLTitle3',
		txt: 'SLText3',
		listing: [ 
			{
				listTxt: 'SLList3_1',
			},
			{
				listTxt: 'SLList3_2',
			},
			{
				listTxt: 'SLList3_3',
			},
			
        ],
	},
    

]


export const ServicesList4 = [
	{
		img: <LazyImage src={ServiceImg4} />,
		title: 'SLTitle4',
		txt: 'SLText4',
		listing: [ 
			{
				listTxt: 'SLList4_1',
			},
			{
				listTxt: 'SLList4_2',
			},
			{
				listTxt: 'SLList4_3',
			},
			
        ],
	},
    

]

export const ServicesList5 = [
	{
		img: <LazyImage src={ServiceImg5} />,
		title: 'SLTitle5',
		txt: 'SLText5',
		listing: [ 
			{
				listTxt: 'SLList5_1',
			},
			{
				listTxt: 'SLList5_2',
			},
			{
				listTxt: 'SLList5_3',
			},
			
        ],
	},
    

]

export const ServicesList6 = [
	{
		img: <LazyImage src={ServiceImg6} />,
		title: 'SLTitle6',
		txt: 'SLText6',
		listing: [ 
			{
				listTxt: 'SLList6_1',
			},
			{
				listTxt: 'SLList6_2',
			},
			{
				listTxt: 'SLList6_3',
			},
			
        ],
	},
    

]

export const ServicesList7 = [
	{
		img: <LazyImage src={ServiceImg7} />,
		title: 'SLTitle7',
		txt: 'SLText7',
		listing: [ 
			{
				listTxt: 'SLList7_1',
			},
			{
				listTxt: 'SLList7_2',
			},
			{
				listTxt: 'SLList7_3',
			},
			
        ],
	},
    

]

export const ServicesList8 = [
	{
		img: <LazyImage src={ServiceImg8} />,
		title: 'SLTitle8',
		txt: 'SLText8',
		listing: [ 
			{
				listTxt: 'SLList8_1',
			},
			{
				listTxt: 'SLList8_2',
			},
			{
				listTxt: 'SLList8_3',
			},
			
        ],
	},
    

]




export const portfolioItems = [
    {
        id: 1,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium1} alt="Portfolio" />,
        
    },
    {
        id: 2,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium2} alt="Portfolio" />,
        
    },
    {
        id: 3,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium3} alt="Portfolio" />,
        
    },
    {
        id: 4,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium4} alt="Portfolio" />,
        
    },
    {
        id: 5,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium5} alt="Portfolio" />,
        
    },
    

    {
        id: 41,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool1} alt="Portfolio" />,
        
    },
    {
        id: 42,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool2} alt="Portfolio" />,
        
    },
    {
        id: 43,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool3} alt="Portfolio" />,
        
    },
    {
        id: 44,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool4} alt="Portfolio" />,
        
    },
    {
        id: 45,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool5} alt="Portfolio" />,
        
    },
    {
        id: 46,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool6} alt="Portfolio" />,
        
    },
    {
        id: 47,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool7} alt="Portfolio" />,
        
    },
    {
        id: 48,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool8} alt="Portfolio" />,
        
    },
    {
        id: 49,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool9} alt="Portfolio" />,
        
    },
    {
        id: 50,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool10} alt="Portfolio" />,
        
    },
    {
        id: 51,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool11} alt="Portfolio" />,
        
    },
    {
        id: 52,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool12} alt="Portfolio" />,
        
    },
    {
        id: 53,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool13} alt="Portfolio" />,
        
    },
    {
        id: 54,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool14} alt="Portfolio" />,
        
    },
    {
        id: 55,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool15} alt="Portfolio" />,
        
    },

    {
        id: 71,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome1} alt="Portfolio" />,
        
    },
    {
        id: 72,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome2} alt="Portfolio" />,
        
    },
    {
        id: 73,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome3} alt="Portfolio" />,
        
    },
    {
        id: 74,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome4} alt="Portfolio" />,
        
    },
    {
        id: 75,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome5} alt="Portfolio" />,
        
    },
    
    {
        id: 91,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior1} alt="Portfolio" />,
        
    },
    {
        id: 92,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior2} alt="Portfolio" />,
        
    },
    {
        id: 93,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior3} alt="Portfolio" />,
        
    },



    
]




export const FaqsList = [
    {
        question: 'question1',
        answer: "answer1",
    },
    {
        question: 'question2',
        answer: "answer2",
    },
    {
        question: 'question3',
        answer: "answer3",
    },
    {
        question: 'question4',
        answer: "answer4",
    },
    {
        question: 'question5',
        answer: "answer5",
    },

]

*/